import RenderComponents from "../RenderComponents";
import React from "react";

const TableCell = ({component, rowIndex, actionsContext, containerArrayPath}) => {
    const {properties: {colSpan} = {},styles: sourceStyles} = component;
    const styles = sourceStyles ? sourceStyles[0] : {};

    const renderer = (
        <div style={{display: 'flex', flexDirection: "column"}}>
            {(component.children || []).map((element, index) => {
                return (
                    <RenderComponents
                        key={index}
                        element={element}
                        containerArrayPath={containerArrayPath}
                        actionsContext={actionsContext}
                    />
                )
            })}
        </div>
    )

    if (rowIndex === 0) {
        return (
            <th style={{
                width: styles.width,
                background: styles.background || "rgba(0, 0, 0, 0.03)",
                padding: styles.padding || 3,
                verticalAlign: styles.justifyContent || "top"
            }}
                colSpan={colSpan}
            >
                {renderer}
            </th>
        )
    }

    return (
        <td style={{
            padding: styles.padding || 3,
            background: styles.background,
            verticalAlign: styles.justifyContent || "top"
        }}
            colSpan={colSpan}
        >
            {renderer}
        </td>
    )
}

export default TableCell
